<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-9">
          <vx-card>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-sm="12"
                vs-md="12"
              >
                <h3>{{ $t('editMachine') }}</h3>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button class="ml-5" icon="arrow_back" to="/machines">{{ $t('back') }}</vs-button>
              </vs-col>

              <vs-col
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button
                  class="mr-5"
                  icon="save"
                  :disabled="!validateForm"
                  @click="updateMachine"
                >{{ $t('save') }}</vs-button>
              </vs-col>
            </vs-row>

            <div class="vx-row justify-content-center mt-3">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  v-validate="'required'"
                  :name="$t('machineName')"
                  :label-placeholder="$t('machineName')"
                  v-model="obj.MachineName"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first($t('machineName')) }}</span>
              </div>
            </div>
            <div class="vx-row justify-content-center">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('teamViewerId')"
                  v-model="obj.TeamViewerId"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('teamViewerPassword')"
                  v-model="obj.TeamViewerPassword"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('anydDeskId')"
                  v-model="obj.AnyDeskId"
                  class="w-full mt-6"
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3">
                <vs-input
                  :label-placeholder="$t('anyDeskPassword')"
                  v-model="obj.AnyDeskPassword"
                  class="w-full mt-6"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import http from "../../../http/http-helper";
export default {
  computed: {
    validateForm() {
      return !this.errors.any() && this.obj.MachineName != "";
    }
  },
  data() {
    return {
      obj: {
        Id: "",
        MachineName: "",
        TeamViewerId: "",
        TeamViewerPassword: "",
        AnyDeskId: "",
        AnyDeskPassword: ""
      }
    };
  },
  methods: {
    // Update Machine
    updateMachine() {
      let path = "/machines/update";

      this.$vs.loading();
      http.post(path, this.obj).then(response => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: this.$t("updated"),
          color: "success"
        });
        this.$router.push("/machines");
      });
    },
    getData() {
      if (this.$route.params.id == null) return this.$router.push("/machines");
      
      this.obj.Id = this.$route.params.id;
      http
        .get(`/machines/getbyid?machineId=${this.$route.params.id}`)
        .then(response => {
          this.obj.MachineName = response.machineName;
          this.obj.TeamViewerId = response.teamViewerId;
          this.obj.TeamViewerPassword = response.teamViewerPassword;
          this.obj.AnyDeskId = response.anyDeskId;
          this.obj.AnyDeskPassword = response.anyDeskPassword;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>